export default {
	quiz: state => state.quiz,
	getInfoQuestion: state => state.question,
	defaultAnswer(state){
		state.quiz.questions.map(
			(x) => state.answer.push({id: x.id, data:[], num: 0})
		);
		return state.answer;
	},
	getNumQuestion: state => state.num_question,
	getStartQuiz: state => state.start_quiz,
	getTimePassed: state => state.time_passed,
	getAnswer: state => state.answer,
	getFinish: state => state.finish,
	getDoneClick: state => state.done_click,
};
